import { FC } from "react";
import { Badge, BadgeSize, BadgeVariant } from "shared/components/Badge";

const DEFAULT_TOOLTIP = "Got a similar unit notification in the last 90 days";

export const SimilarUnitBadge: FC<{
  className?: string;
  size?: BadgeSize;
  tooltip?: string;
}> = ({ className, size = BadgeSize.SM, tooltip = DEFAULT_TOOLTIP }) => (
  <Badge
    variant={BadgeVariant.PRIMARY}
    size={size}
    className={className}
    placement="top"
    tooltip={tooltip}
    tooltipClassName="max-w-[240px]"
    leftElement={<span aria-hidden="true">↻</span>}
  >
    Similar unit
  </Badge>
);
